import Headroom from 'headroom.js';
import { Component } from 'js-component-framework';

/**
 * Component for instantiating Site Navigation
 */
export default class SiteNavigation extends Component {

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Init sticky Nav
    if (this.element.classList.contains(this.options.stickyClass)) {
      this.headroom = new Headroom(
        this.element,
        this.options.headroom
      );
      this.headroom.init();
    }

    // Init sub-navigation
    this.triggerSubNav();
  }

  /**
   * Trigger sub-navigation
   */
  triggerSubNav() {
    Array.prototype.forEach.call(this.children.menuItemParents, (el) => {
      el.addEventListener('mouseenter', (event) => {
        event.currentTarget.classList.add(this.options.subNavActiveClass);
        event.currentTarget.setAttribute('aria-expanded', 'true');
      });
      el.addEventListener('mouseleave', (event) => {
        event.currentTarget.classList.remove(this.options.subNavActiveClass);
        event.currentTarget.setAttribute('aria-expanded', 'false');
      });
    });
  }
}



// WEBPACK FOOTER //
// ./client/js/components/Header/SiteNavigation.js